export const getCollaboratorRoleLabel = (isLead: boolean, isOwner: boolean, eduPersonPrincipalName: string) => {
  if (isLead && isOwner) {
    return 'Owner + Lead investigator'
  }
  if (isLead) {
    return 'Lead investigator'
  }
  if (isOwner) {
    return 'Owner'
  }
  if (eduPersonPrincipalName.endsWith('@uq.edu.au')) {
    return 'UQ collaborator'
  }
  return 'External collaborator'
}
